//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import QuestionFile from 'components/AliyunOSS/QuestionBankFile.vue';
export default {
  name: 'choice',
  components: {
    QuestionFile: QuestionFile
  },
  props: {
    data: {
      type: Object,
      default: null
    },
    childQuestionList: {
      default: []
    }
  },
  created: function created() {
    this.filesList = this.data.stemFiles;
  },
  data: function data() {
    return {
      urlAliyunOSS: '/api/XOrg/AssociationIndex/getSign',
      // 题干附件
      fileList: [],
      fileIds: [],
      // 附件Id
      filesList: [],
      selects: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V']
    };
  },
  methods: {}
};